/**
 * Created by Ning Jiang on 11/22/2016.
 */

///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomWiggle.d.ts"/>
///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomBounce.d.ts"/>
import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {DeadwoodGameModuleConfig} from "./DeadwoodGameModuleConfig";
import {DeadwoodWinFieldController} from "./winpresentation/initial/DeadwoodWinFieldController";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {APIBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIBetType} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetType";

require("../../node_modules/gsap/src/uncompressed/plugins/PixiPlugin");

export class Deadwood extends SlotGame {

    constructor() {
        super(DeadwoodGameModuleConfig.instance);
    }


    public init(): Promise<NolimitPlugin> {
        return super.init().then((plugin: NolimitPlugin) => {

            SlotGame.api.betHandler.addBetDataInjectCallback((data:APIBetEventData)=>this.injectExternalFreeBetCallback(data));

            return plugin;
        });
    }

    private injectExternalFreeBetCallback(betData:APIBetEventData) {
        if (betData.type === APIBetType.FREE_BET){
            (<any>betData).replayAndFeatureBuy = true; //Sort of a hack, this parameter is checked in balance.js. If true, it will skip balance - bet check. And allow "normal" bets to be done without checking that you can afford to make the bet.
        }
        return betData;
    }

    protected createWinFieldController(): WinFieldController {
        return new DeadwoodWinFieldController();
    }


    public getReady(): Promise<NolimitPlugin> {
        return super.getReady().then((plugin: NolimitPlugin) => {
            return plugin;
        });
    }

    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M2",
                    "M5",
                    "L1",
                    "L2",
                    "M4",
                    "L3"
                ],
                [
                    "L3",
                    "M1",
                    "M5",
                    "L2",
                    "M4",
                    "L4"
                ],
                [
                    "L1",
                    "M3",
                    "M2",
                    "L3",
                    "M3",
                    "M4"
                ],
                [
                    "L3",
                    "L4",
                    "L5",
                    "L1",
                    "M1",
                    "M3"
                ],
                [
                    "L1",
                    "L4",
                    "M4",
                    "M5",
                    "L2",
                    "M4"
                ]
            ],
            "evaluatedArea": [
                [
                    "X",
                    "L1",
                    "L2",
                    "M4"
                ],
                [
                    "M1",
                    "M5",
                    "L2",
                    "M4"
                ],
                [
                    "M3",
                    "M2",
                    "L3",
                    "M3"
                ],
                [
                    "L4",
                    "L5",
                    "L1",
                    "M1"
                ],
                [
                    "X",
                    "M4",
                    "M5",
                    "L2"
                ]
            ],
            "betWayWins": [],
            "totalBetWayWinnings": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "currentMultiplier": 1,
            "freespinTriggeredThisSpin": false,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "freespinMultiplierBefore": 1,
            "freespinMultiplierAfter": 1,
            "overlayWilds": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "overlayWildsBeforeSpin": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "doReelNudge": [
                false,
                false,
                false,
                false,
                false
            ],
            "extraSymbolsOnTop": [
                [
                    "L4",
                    "L3",
                    "L1"
                ],
                [
                    "L2",
                    "M3",
                    "M4"
                ],
                [
                    "M3",
                    "L4",
                    "L3"
                ],
                [
                    "M2",
                    "L4",
                    "M1"
                ],
                [
                    "M4",
                    "L4",
                    "L3"
                ]
            ],
            "bonusPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "multiplierOnReel": [
                0,
                0,
                0,
                0,
                0
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "fsSuperModeActive": false,
            "bonusTriggeredThisSpin": false,
            "playerFSSelection": -1,
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 71
                },
                {
                    "name": "FREESPIN_BOUNTY",
                    "type": "FREESPIN",
                    "price": 750
                }
            ],
            "wasFeatureBuy": false,
            "featureBet": false,
            "numberOfSpinsFreespin": [
                0,
                0
            ]
        };
    }


    getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {
            value = value.replace(new RegExp("#isGreece", "g"), (Deadwood.api.gameClientConfiguration.jurisdictionName !== "GR" ? "isGreeceJur" : ""));
            return value;
        });
    }
}
